function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 9.526c.442 0 .8.354.8.79 0 .436-.358.79-.8.79a.795.795 0 01-.8-.79c0-.436.358-.79.8-.79zm3.2 0c.442 0 .8.354.8.79 0 .436-.358.79-.8.79a.795.795 0 01-.8-.79c0-.436.358-.79.8-.79zm-6.4 0c.442 0 .8.354.8.79 0 .436-.358.79-.8.79a.795.795 0 01-.8-.79c0-.436.358-.79.8-.79zm9.6 4.737c0 .435-.36.79-.8.79H9.243c-.434 0-.861.116-1.235.337L5.6 16.816V6.368c0-.435.36-.79.8-.79h11.2c.44 0 .8.355.8.79v7.895zM17.6 4H6.4C5.077 4 4 5.063 4 6.368V18.21c0 .285.155.548.406.687a.805.805 0 00.806-.01l3.62-2.143a.806.806 0 01.411-.112H17.6c1.323 0 2.4-1.063 2.4-2.369V6.368C20 5.063 18.923 4 17.6 4z"
});

function SvgReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
}

export default SvgReview;